import { useTranslation } from 'react-i18next'

export function LanguageSwitcher() {
  const { i18n } = useTranslation()
  const current = i18n.language.startsWith('en') ? 'en' : 'fi'

  return (
    <div className="flex items-center gap-1 text-sm">
      <button
        onClick={() => i18n.changeLanguage('fi')}
        className={current === 'fi' ? 'font-bold underline' : 'opacity-60 hover:opacity-100'}
        aria-label="Suomi"
      >FI</button>
      <span className="opacity-40">|</span>
      <button
        onClick={() => i18n.changeLanguage('en')}
        className={current === 'en' ? 'font-bold underline' : 'opacity-60 hover:opacity-100'}
        aria-label="English"
      >EN</button>
    </div>
  )
}
